<div class="box box-info">
  <div class="box-header with-border">
    <h3 class="box-title">Edit staff</h3>
  </div>
  <!-- /.box-header -->
  <!-- form start -->
  <form role="form" [formGroup]="form">
    <div class="box-body">
      <div class="form-group col-sm-6 col-xs-12">
        <label for="first_name">First Name*</label>
        <input
          type="text"
          class="form-control"
          formControlName="first_name"
          placeholder="First Name"
          />
        @if (
          form.controls['first_name'].hasError('required') &&
          (isSubmitted || form.controls['first_name'].touched)
          ) {
          <control-message
            message="This field is required."
          ></control-message>
        }
      </div>
      <div class="form-group col-sm-6 col-xs-12">
        <label for="last_name">Last Name*</label>
        <input
          type="text"
          class="form-control"
          formControlName="last_name"
          placeholder="Last Name"
          />
        @if (
          form.controls['last_name'].hasError('required') &&
          (isSubmitted || form.controls['last_name'].touched)
          ) {
          <control-message
            message="This field is required."
          ></control-message>
        }
      </div>
      <div class="form-group col-sm-6 col-xs-12">
        <label for="email">Email*</label>
        <input
          type="email"
          class="form-control"
          formControlName="email"
          placeholder="Email"
          />
        @if (
          form.controls['email'].hasError('required') &&
          (isSubmitted || form.controls['email'].touched)
          ) {
          <control-message
            message="This field is required."
          ></control-message>
        }
        @if (
          form.controls['email'].hasError('pattern') &&
          (isSubmitted || form.controls['email'].touched)
          ) {
          <control-message
            message="This email is not valid."
          ></control-message>
        }
      </div>
      <div class="form-group col-sm-6 col-xs-12">
        <label for="mobileno">Mobile Number*</label>
        <input
          type="text"
          class="form-control"
          formControlName="mobileno"
          placeholder="Mobile Number"
          maxlength="9"
          />
        @if (
          form.controls['mobileno'].hasError('required') &&
          (isSubmitted || form.controls['mobileno'].touched)
          ) {
          <control-message
            message="This field is required."
          ></control-message>
        }
        @if (
          form.controls['mobileno'].hasError('pattern') &&
          (isSubmitted || form.controls['mobileno'].touched)
          ) {
          <control-message
            message="This number is not valid."
          ></control-message>
        }
      </div>
      <div class="form-group col-sm-6 col-xs-12">
        <label for="user_type">User Type*</label>
        <select class="form-control" formControlName="user_type" (change)="userTypeChange()">
          <option value="">select a user type</option>
          @for (item of user_types; track item; let i = $index) {
            <option
              value="{{ item.name }}"
              >{{ item.name }}</option
              >
            }
          </select>
          @if (
            form.controls['user_type'].hasError('required') &&
            (isSubmitted || form.controls['user_type'].touched)
            ) {
            <control-message
              message="This field is required."
            ></control-message>
          }
        </div>
        @if (showSusbcriptions) {
          <div class="form-group col-sm-6 col-xs-12">
            <label for="susbscription_type">Subscription</label>
            <select class="form-control" formControlName="susbscription_type">
              <option value="">select a subscription type</option>
              @for (item of susbscription_types; track item; let i = $index) {
                <option
                  [value]="item.title"
                  >{{ item.title }}</option
                  >
                }
              </select>
              <!-- <control-message
          *ngIf="
            form.controls['susbscription_type'].hasError('required') &&
            (isSubmitted || form.controls['susbscription_type'].touched) 
          "
              message="This field is required."
            ></control-message> -->
          </div>
        }
      </div>
      <!-- /.box-body -->

      <div class="box-footer">
        <button type="submit" (click)="submitForm()" class="btn btn-success">
          Submit
        </button>
      </div>
    </form>
  </div>
